import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { MenuIcon, XIcon } from "@heroicons/react/outline";

function LandingHeader() {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="bg-background w-full sticky top-0 z-50 shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img
              className="h-8 w-auto"
              src={require("../assets/logoon.png")}
              alt="Logo"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <HashLink
              className="text-gray-700 hover:text-gray-900 font-medium font-robo"
              smooth
              to="/#home"
            >
              Home
            </HashLink>
            <HashLink
              className="text-gray-700 hover:text-gray-900 font-medium font-robo"
              smooth
              to="/#about"
            >
              About
            </HashLink>
            <HashLink
              className="text-gray-700 hover:text-gray-900 font-medium font-robo"
              smooth
              to="/#contact"
            >
              Contact
            </HashLink>
            <button
              className="text-gray-700 hover:text-gray-900 font-medium font-robo"
              onClick={() => navigate("/forum")}
            >
              Forum
            </button>
          </nav>

          {/* Desktop Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <button
              className="font-robo font-semibold border border-gray-300 hover:bg-gray-50 rounded-md py-2 px-4 text-sm"
              onClick={() => navigate("/sign-up")}
            >
              Sign up
            </button>
            <button
              className="py-2 px-4 rounded-md shadow-sm text-sm font-robo font-semibold bg-palette_color1 hover:opacity-90 text-white"
              onClick={() => navigate("/login")}
            >
              Log in
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              className="text-gray-500 hover:text-gray-700"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? (
                <XIcon className="h-6 w-6" />
              ) : (
                <MenuIcon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`${isMobileMenuOpen ? 'block' : 'hidden'} md:hidden`}>
        <div className="px-2 pt-2 pb-3 space-y-1 bg-white shadow-lg">
          <HashLink
            className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md"
            smooth
            to="/#home"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Home
          </HashLink>
          <HashLink
            className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md"
            smooth
            to="/#about"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            About
          </HashLink>
          <HashLink
            className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md"
            smooth
            to="/#contact"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Contact
          </HashLink>
          <button
            className="block w-full text-left px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md"
            onClick={() => {
              navigate("/forum");
              setIsMobileMenuOpen(false);
            }}
          >
            Forum
          </button>
          <div className="pt-4 pb-3 border-t border-gray-200">
            <div className="flex items-center px-5">
              <button
                className="w-full font-robo font-semibold border border-gray-300 hover:bg-gray-50 rounded-md py-2 px-4 text-sm"
                onClick={() => {
                  navigate("/sign-up");
                  setIsMobileMenuOpen(false);
                }}
              >
                Sign up
              </button>
              <button
                className="ml-3 w-full py-2 px-4 rounded-md shadow-sm text-sm font-robo font-semibold bg-palette_color1 hover:opacity-90 text-white"
                onClick={() => {
                  navigate("/login");
                  setIsMobileMenuOpen(false);
                }}
              >
                Log in
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default LandingHeader;
